export default class Stores {
  static AuthenticationStore = "authenticationStore"
  static RoleStore = "roleStore"
  static UserStore = "userStore"
  static SessionStore = "sessionStore"
  static AccountStore = "accountStore"
  static LanguageStore = "languageStore"
  static AppDataStore = "appDataStore"

  // Master data
  static MasterDataStore = "masterDataStore"
  static CustomerSourceStore = "customerSourceStore"
  static ProjectFacilityStore = "projectFacilityStore"
  static TownShipStore = "townShipStore"
  static TownshipAreaStore = "townshipAreaStore"
  static UnitDesignStore = "unitDesignStore"
  static UnitFacilityStore = "unitFacilityStore"
  static UnitTypeStore = "unitTypeStore"
  static ProjectMasterStore = "projectMasterStore"
  static UnitMasterStore = "unitMasterStore"
  static ZoneStore = "zoneStore"
  static FloorStore = "floorStore"
  static TowerStore = "towerStore"
  static PaymentMasterStore = "paymentMasterStore"
  static PropertyTypeStore = "propertyTypeStore"
  static ViewStore = "viewStore"
  static PaymentRequestStore = "paymentRequestStore"

  // Accounting Data
  static AccountTypeStore = "accountTypeStore"
  static AccountingDocumentTypeStore = "accountingDocumentTypeStore"
  static CostCenterStore = "costCenterStore"
  static OffsetAccountStore = "offsetAccountStore"

  // Fee
  static FeeTypeStore = "feeTypeStore"

  // File / Import
  static FileStore = "fileStore"
  static ImportStore = "importStore"

  // Common
  static CommentStore = "commentStore"
  static NotificationTemplateStore = "notificationTemplateStore"

  // Client Management
  static CompanyStore = "companyStore"

  // Organization
  static OrganizationUnitStore = "organizationUnitStore"

  // Activity
  static ProposalStore = "proposalStore"
  static ActivityStore = "activityStore"
  static SiteVisitStore = "siteVisitStore"

  // Project
  static UnitStore = "unitStore"

  // Inquiry
  static InquiryStore = "inquiryStore"

  // CRM
  static FilterStore = "filterStore"
  static PinkBookStore = "pinkBookStore"
  static CustomerStore = "customerStore"
  static CustomerPotentialStore = "customerPotentialStore"
  static ApprovalStore = "approvalStore"

  // Trading Floor
  static AgencyMasterStore = "agencyMasterStore"
  static AgencyMasterGroupStore = "agencyMasterGroupStore"

  // Floor and Staff
  static TradingFloorStore = "tradingFloorStore"
  static FloorStaffStore = "floorStaffStore"
  static BussinessTargetStore = "bussinessTargetStore"
  static AllocatedCustomerStore = "allocatedCustomerStore"

  // Phase / Config / System
  static PhaseCodeStore = "phaseCodeStore"
  static SystemConfigurationStore = "systemConfigurationStore"
  static ApprovalProcessStore = "approvalProcessStore"
  static ConfigHolidayStore = "configHolidayStore"
  static BlockUserStore = "blockUserStore"
}
